import React from 'react';
import './PortfolioSingle.css';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const PortfolioSingle = () => { 

  // Get portfolio details passed via router state
  const location = useLocation();  
  const portfolioSingle = location.state; 

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={'Portfolio Single'} page={'Portfolio Single'} />

      <section className='portfolio-single page-single'>

        <div className='portfolio-info page-info'>

          {/* portfolio Image Section */}
          <div className='image'>
            <img src={portfolioSingle.image} alt={portfolioSingle.title} />
          </div>

          <div className='content'>

            {/* portfolio Title */}
            <h3 className='main-heading'>{portfolioSingle.title}</h3>

            {/* portfolio Description */}
            {portfolioSingle.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* portfolio Image Gallery */}
            <Lightbox images={portfolioSingle.gallery} />

            {/* Portfolio Challenges Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Challenges Faced:</h3>

              {/* Introduction to challenges */}
              <p>{portfolioSingle.challenges.intro}</p>
              
              {/* List of Portfolio Challenges */}
              <ul>
                {portfolioSingle.challenges.points.map((challenge, index) => {
                  return <li key={index}><FaCheck className='icon' />{challenge}</li>
                })}
              </ul>

            </div>

            {/* portfolio Solutions Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Solutions Provided:</h3>

              {/* Introduction to solutions */}
              <p>{portfolioSingle.solutions.intro}</p>

              {/* List of solutions */}
              <ul>
                {portfolioSingle.solutions.points.map((solution, index) => {
                  return <li key={index}><FaCaretRight className='icon' />{solution}</li>
                })}
              </ul>

            </div>

            {/* portfolio Results Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Results & Impact:</h3>

              {/* Introduction to results */}
              <p>{portfolioSingle.results.intro}</p>
              
              {/* List of achieved results */}
              <ul>
                {portfolioSingle.results.points.map((result, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{result}</li>
                })}
              </ul>

            </div>

          </div> 
        
        </div> 

        {/* Sidebar with project details */}
        <PageSidebar
          heading={'portfolio'}
          details={portfolioSingle.details}
        />

      </section>

    </> 
  );
}

export default PortfolioSingle;